var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import BalanceMenu from './BalanceMenu';
var Balance = /** @class */ (function (_super) {
    __extends(Balance, _super);
    function Balance() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            balanceVisible: true
        };
        _this.toggleBalance = function (e) {
            e.preventDefault();
            _this.setState({
                balanceVisible: !_this.state.balanceVisible
            });
        };
        return _this;
    }
    Balance.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return nextProps.balance !== this.props.balance || nextState !== this.state || this.props.userMenuToggled !== nextProps.userMenuToggled || this.props.balanceLoad !== nextProps.balanceLoad;
    };
    ;
    Balance.prototype.render = function () {
        var balanceVisible = this.state.balanceVisible;
        var _a = this.props, user = _a.user, signOutAction = _a.signOutAction, balance = _a.balance, freebets = _a.freebets, betSlipsSize = _a.betSlipsSize, openBetSlipModal = _a.openBetSlipModal, toggleUserMenu = _a.toggleUserMenu, userMenuToggled = _a.userMenuToggled, fetchBalanceAction = _a.fetchBalanceAction, balanceLoad = _a.balanceLoad;
        var menuProps = {
            fetchBalanceAction: fetchBalanceAction,
            balanceLoad: balanceLoad,
            user: user,
            balanceVisible: balanceVisible,
            balance: balance,
            freebets: freebets,
            signOutAction: signOutAction,
            toggleBalance: this.toggleBalance,
            betSlipsSize: betSlipsSize,
            openBetSlipModal: openBetSlipModal,
            toggleUserMenu: toggleUserMenu,
            userMenuToggled: userMenuToggled
        };
        var renderBalance = balanceVisible && _jsx("span", __assign({ className: 'number' }, { children: balance !== null ? balance : 'Loading...' }));
        return (_jsxs(Fragment, { children: [_jsxs("div", __assign({ className: "m_balance ".concat(!userMenuToggled ? 'active' : ''), onClick: toggleUserMenu }, { children: [_jsx("img", { src: require('./../../assets/img/userpic.svg'), alt: '' }), !userMenuToggled && renderBalance] })), _jsx(BalanceMenu, __assign({}, menuProps))] }));
    };
    return Balance;
}(React.Component));
Balance.propTypes = {
    balance: PropTypes.number,
    freebets: PropTypes.array,
    signOutAction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    betSlipsSize: PropTypes.number.isRequired,
    openBetSlipModal: PropTypes.func.isRequired,
    toggleUserMenu: PropTypes.func.isRequired,
    fetchBalanceAction: PropTypes.func.isRequired,
    userMenuToggled: PropTypes.bool.isRequired,
    balanceLoad: PropTypes.any,
};
export default Balance;



// WEBPACK FOOTER //
// ./src/components/header/Balance.jsx